const patterns = {
    // Minimum 8 characters, at least one uppercase letter, one lowercase letter and one number:
    PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/,
    EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}

const Expect = () => {
    const validators = []
    const patterns = {
        password: [
            { pattern: /[a-z]/, message: "At least one lowercase letter" },
            { pattern: /[A-Z]/, message: "At least one uppercase letter" },
            { pattern: /\d/, message: "At least one number" },
            { pattern: /.{8,}/, message: "Minimum 8 characters" }
        ]
    }

    return {
        notSameAs(name, error = `Same as ${name}`) {
            validators[`notSameAs#${name}`] = (value, formValue) => {
                if (value !== formValue[name]) return null
                return error
            }
            return this
        },
        sameAs(name, error = "Didn't match") {
            validators[`sameAs#${name}`] = (value, formValue) => {
                if (value === formValue[name]) return null
                return error
            }
            return this
        },
        patterns(name) {
            validators[`patterns#${name}`] = (value) => {
                const errs = []
                for (const { pattern, message } of patterns[name]) {
                    if (!pattern.test(value)) {
                        errs.push(message)
                    }
                }
                return errs.length ? errs : null
            }
            return this
        },
        range(start, end) {
            validators[`range#${name}`] = (value) => {
                const errs = []
                const val = Number(value)
                if (isNaN(val)) {
                    errs.push("The input value must be number")
                }
                if (!(start <= val && val <= end)) {
                    errs.push(`The input value must be between ${start} and ${end}.`)
                }
                return errs.length ? errs : null
            }
            return this
        },
        end() {
            return (value, formValue) => {
                let message
                for (const func of Object.values(validators)) {
                    message = func(value, formValue)
                    if (Array.isArray(message) && message.length) {
                        message = message.join("$&$")
                        break
                    }
                    if (typeof message === "string") break
                }
                return message
            }
        }
    }
}

Expect.patterns = patterns
export default Expect
